import styled from '@emotion/styled';

export const SuffixWrapper = styled.span({
  padding: '0 4px',
});
